export const phrase = (message, symbol = '.') => `${message}${message.endsWith(symbol) ? '' : symbol}`;
